import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

function Spinner(props) {
  const [loadText, setLoadText] = useState("Saved");

  const spinnerStyle = {
    maxWidth: "40px",
    position: "absolute",
    top: "50%",
    transform: "translate(-50%,-50%)",
    zIndex: "999",
  };

  const loading = useSelector((state) => state.editorLoading);

  useEffect(() => {
    if (loading.loading) {
      setLoadText("Saving");
    } else {
      setLoadText("Saved ");
    }
  }, [loading]);

  return (
    <>
      <div className="resume-options d-flex">
        <div className="">
          <button type="button" className="btn btn-primary resume-options">
            {loadText}
          </button>
        </div>
        <div className="">
          <img
            src={
              loading && loading.loading
                ? `${process.env.REACT_APP_COMMON_ASSET_PATH}/edit_loading.gif`
                : `${process.env.REACT_APP_COMMON_ASSET_PATH}/checkmark.svg`
            }
            style={spinnerStyle}
            alt="loading"
            className=""
          />
        </div>
      </div>
    </>
  );
}

export default Spinner;
